
  
// const loadImagenesProductoCaratula = async (idProducto) => {
//   const imagenes = [];
//   let i = 1;

//   while (true) {
//     try {
//       // Intenta cargar la imagen
//       const img = await import(`../assets/Imagenes/Productos-Caratulas/${idProducto}/${idProducto}-${i}.png`);
//       imagenes.push(img.default); // `.default` es necesario con Webpack

//       i++; // Incrementa el contador para la siguiente imagen
//     } catch (error) {
//       // Si no se puede cargar la imagen, significa que no hay más imágenes
//       break; // Salir del bucle si no se encuentra la imagen
//     }
//   }

//   return imagenes;
// };

// export default loadImagenesProductoCaratula;



const importAll = (r) => {
  const images = {};
  r.keys().forEach((key) => {
    const match = key.match(/\.\/(\d+)\/\1-(\d+)\.png$/);
    if (match) {
      const idProducto = match[1];
      if (!images[idProducto]) {
        images[idProducto] = [];
      }

      const img = r(key); // esto puede ser una string o un objeto con .default
      const src = img?.default ?? img; // toma el valor correcto según el caso
      images[idProducto].push(src);
    }
  });

  Object.keys(images).forEach((id) => {
    images[id].sort((a, b) => {
      const n1 = parseInt(a.match(/-(\d+)\.png$/)?.[1] ?? 0);
      const n2 = parseInt(b.match(/-(\d+)\.png$/)?.[1] ?? 0);
      return n1 - n2;
    });
  });

  return images;
};

const CatalogoImagenesProductosExtras = importAll(
  require.context('../assets/Imagenes/Productos_Caratulas', true, /\.png$/)
);

export default CatalogoImagenesProductosExtras;